<template>
  <div id="foottracks" v-if="timelineData">
    <h1>I CAME ALONG THESE HILLS</h1>
    <v-tabs :tabs="tabs" flexColumn>
      <div slot="beforeTabLinks">
        <img src="../assets/img/foottracks.jpg" alt="Sonja Roef" width="500px">
        <div>SONJA ROEF, née le 12 mai 1952 à Luxembourg</div>
      </div>
        <div :slot="tabs[0]" class="mt-70">
          expositions personnelles
          <v-timeline :data="timelineData.exposPersonnelles" :options="timlineOptions"></v-timeline>
        </div>
        <div :slot="tabs[1]" class="mt-70">
          autres dates / réalisations / distinctions
          <v-timeline :data="timelineData.autreDates" :options="timlineOptions"></v-timeline>
        </div>
        <div :slot="tabs[2]" class="mt-70">
          expositions en collectivité avec d’autres artistes, sélection:
          <v-timeline :data="timelineData.exposCollective" :options="timlineOptions"></v-timeline>
        </div>
        <div :slot="tabs[3]" class="mt-70">
          catalogues et publications
          <v-timeline :data="timelineData.catalogues" :options="timlineOptions"></v-timeline>
        </div>
        <div :slot="tabs[4]" class="mt-70">
          collections
          <v-timeline :data="timelineData.collections" :options="timlineOptions"></v-timeline>
        </div>
    </v-tabs>

  </div>
</template>

<script>
import timelines from '@/assets/js/timelines.js'

export default {
  name: 'Foottracks',
  data () {
    return {
      tabs: [
        'expositions personnelles',
        'autres dates / réalisations / distinctions',
        'expositions en collectivité',
        'catalogues / publications',
        'collections'
      ],
      timlineOptions: {
        showMarkers: false,
        showMarkersOnLeft: true,
        textBoxStyle: 'simple'
      },
      timelineData: timelines
    }
  }
}
</script>

<style lang="scss">
#foottracks {
  img {
    max-width: 100%;
  }
}
@media screen and (max-width: 700px) {
  #foottracks {
    .mt-70 {
      margin-top: 50px;
    }
    .tab-links-wrapper {
      flex-flow: column;
      ul {
        margin: 30px 0 0 0;
        li {
          margin: 0;
        } 
      }
    }
  }
}
</style>
